export const STORAGE_KEY = 'zorro-ai-auth';

export interface AuthCredentials {
  email: string;
  password: string;
}

export function readCredentials(): AuthCredentials | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AuthCredentials;
    if (!parsed.email || !parsed.password) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeCredentials(creds: AuthCredentials): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(creds));
}

export function clearCredentials(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function basicAuthHeader(creds: AuthCredentials): string {
  return `Basic ${btoa(`${creds.email}:${creds.password}`)}`;
}
